export const ESTOQUE_ENTRADA_TIPO_DUPLICATA = [
    {
        id: 'A_VISTA',
        descricao: "À Vista",
    },
    {
        id: 'PARCELADA',
        descricao: "À Prazo",
    },
];